import React from 'react';
import logo from './med.png';
import './App.css';
import MyLocation from "./MyLocation"
function App() {

  return (
    <div className="App">
      <header className="App-header">
        <img src={logo} className="App-logo" alt="logo" />
        <a
          className="App-link"
          href="https://reactjs.org"
          target="_blank"
          rel="noopener noreferrer"
        >
          Learn React
        </a>
        <MyLocation/>
      </header>
    </div>
  );
}

export default App;
